import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnersDisplayGridRowDataFragmentGql } from './OwnersDisplayGridRowFragmentGql';

// Should fetch same nodes as FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQuery
export const FlowDownstreamOwnersFilteredByFlowOutputFieldQueryGql: DocumentNode = gql`
query FlowDownstreamOwnersFilteredByFlowOutputFieldQuery(
  $flowVizportalUrlId: String!,
  $selectedFlowOutputFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: TableauUserSortOrder!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    outputFieldsConnection(filter: { id: $selectedFlowOutputFieldId }) {
      nodes {
        downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...OwnersDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${OwnersDisplayGridRowDataFragmentGql}
`;
